import { getAdminsAccountManagers } from "../../../api/admins";
import { languageTempletsOptions } from "../../../utils/langTemplets";

export const MASTER_FIELDS = [
  { key: "amount", label: "Master amount", type: "number" },
  // { key: "current", label: "Master current", type: "number" },
  {
    key: "paymentTerms",
    label: "payment Terms",
    type: "fixed-select",
    options: [
      { label: "Prepaid", value: "Prepaid" },
      { label: "Instant", value: "Instant" },
      { label: "Net 7", value: "Net 7" },
      { label: "Net 14", value: "Net 14" },
      { label: "Net 30", value: "Net 30" },
      { label: "Net 45", value: "Net 45" },
      { label: "Net 60", value: "Net 60" },
      { label: "Net 90", value: "Net 90" },
    ],
  },
  { key: "creditInsurance", label: "credit Insurance" },
  { key: "creditInsuranceFee", label: "credit Insurance Fee", type: "number" },
  { key: "accountingId", label: "accounting Id" },
  { key: "creditLine", label: "credit Line", type: "checkbox" },
];

export const MEDIA_FIELDS_REQUIRED = [
  { key: "name", label: "Name" },
  { key: "kvk_number", label: "kvk_number" },
  { key: "btw_number", label: "btw_number" },
  { key: "telephone", label: "general_phone_number" },

  { key: "street", label: "Visit address street" },
  { key: "house_number", label: "Visit address house_number" },
  { key: "zip_code", label: "Visit address zip_code" },
  { key: "city", label: "Visit address city" },

  { key: "postal_address_street", label: "postal_address_street" },
  { key: "postal_address_country", label: "postal_address_country" },
  { key: "postal_address_zip_code", label: "postal_address_zip_code" },
  { key: "postal_address_city", label: "postal_address_city" },

  { key: "bank_account_number", label: "bank_account_number" },
  { key: "formal_employment_provider", label: "formal_employment_provider" },

  {
    key: "formal_employment_provider_position",
    label: "formal_employment_provider_position",
  },
  {
    key: "formal_employment_provider_contact_details",
    label: "formal_employment_provider_contact_details",
  },
  { key: "formal_provider_details", label: "formal_provider_details" },

  {
    key: "account_manager_id",
    label: "account_manager_wsb_partner",
    type: "select",
    apiResKey: "admins",
    api: getAdminsAccountManagers,
  },

  { key: "operational_work_provider", label: "operational_work_provider" },
  {
    key: "operational_work_provider_function",
    label: "operational_work_provider_function",
  },
  {
    key: "operational_work_provider_contact_details",
    label: "operational_work_provider_contact_details",
  },

  { key: "other_work_locations", label: "other_work_locations" },
  { key: "active_pools", label: "active_pools", type: "number" },
  { key: "invoices_sent", label: "invoices_sent", type: "number" },
  { key: "invoice_amount", label: "invoice_amount", type: "number" },
  { key: "hours_worked", label: "hours_worked", type: "number" },

  { key: "paymentTerms", label: "payment_terms_in_days", type: "number" },

  { key: "invoice_email", label: "invoice email", type: "email" },
  {
    key: "preferredLanguage",
    label: "Prefered Language",
    type: "fixed-select",
    options: [...languageTempletsOptions],
  },

  {
    key: "threePartyAgreement",
    label: "Three Party Agreement",
    type: "file-v2",
  },
  {
    key: "mandate",
    label: "Mandate",
    type: "file-v2",
  },
];

export const MEDIA_FIELDS_NOT_REQUIRED = [
  { key: "VAT_transferred", label: "VAT transferred", type: "checkbox" },
];

export const MEDIA_FIELDS = [
  ...MEDIA_FIELDS_REQUIRED,
  ...MEDIA_FIELDS_NOT_REQUIRED,
];

const FIELDS = [...MEDIA_FIELDS, ...MASTER_FIELDS];

export default FIELDS;
